import { defineComponent } from 'vue'

import { TRUNCATE_LENGTHS } from '@/config'

const truncateFilter = (maxLength: number) => (text: string | null | undefined) => {
  if (text && text?.length > maxLength) return text.slice(0, maxLength) + '…'
  return text ?? ''
}

export const truncateSelect = truncateFilter(TRUNCATE_LENGTHS.select)
export const truncateLong = truncateFilter(TRUNCATE_LENGTHS.long)
export const truncateShort = truncateFilter(TRUNCATE_LENGTHS.short)
export const truncateNotification = truncateFilter(TRUNCATE_LENGTHS.notification)
export const truncateId = truncateFilter(TRUNCATE_LENGTHS.id)

export default defineComponent({
  methods: {
    truncateSelect,
    truncateLong,
    truncateShort,
    truncateNotification,
    truncateId,
  },
})
